import { useState, useEffect } from "react";
import servicesData from "../data/services.json";
import ServiceListCard from "../components/cards/ServiceListCard";
import PageHeader from "../components/common/PageHeader";

export default function Internships() {
  const [search, setSearch] = useState("");

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const filteredInternships = servicesData.internships.filter((internship) =>
    internship.title.toLowerCase().includes(search.toLowerCase()),
  );

  return (
    <div className="max-w-7xl mx-auto px-6 py-16">
      <PageHeader title="Internships" search={search} setSearch={setSearch} />

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-10">
        {filteredInternships.length > 0 ? (
          filteredInternships.map((internship) => (
            <ServiceListCard
              key={internship.slug}
              item={internship}
              type="internships"
            />
          ))
        ) : (
          <div className="col-span-full text-center py-20">
            <p className="text-gray-500 text-lg">No internships found 😕</p>
          </div>
        )}
      </div>
    </div>
  );
}
